import * as React from 'react';

var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgUv = function SvgUv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M20 38.5c10.217 0 18.5-8.283 18.5-18.5S30.217 1.5 20 1.5 1.5 9.783 1.5 20 9.783 38.5 20 38.5ZM40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M20 8a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 20 8ZM28.485 11.515a.75.75 0 0 1 0 1.06l-1.06 1.061a.75.75 0 1 1-1.061-1.06l1.06-1.061a.75.75 0 0 1 1.061 0ZM13.636 26.364a.75.75 0 0 1 0 1.06l-1.06 1.061a.75.75 0 1 1-1.061-1.06l1.06-1.061a.75.75 0 0 1 1.061 0ZM8 20a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 8 20ZM29 20a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5A.75.75 0 0 1 29 20ZM11.515 11.515a.75.75 0 0 1 1.06 0l1.061 1.06a.75.75 0 1 1-1.06 1.061l-1.061-1.06a.75.75 0 0 1 0-1.061ZM16.373 13.442a7.487 7.487 0 0 1 10.67 9.059.75.75 0 0 1-1.413-.502 5.987 5.987 0 1 0-6.964 3.84.75.75 0 0 1-.332 1.463 7.487 7.487 0 0 1-1.961-13.86Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2E31",
    fillRule: "evenodd",
    d: "M22.25 25.25A.75.75 0 0 1 23 26v3.75a.75.75 0 0 0 1.5 0V26a.75.75 0 0 1 1.5 0v3.75a2.25 2.25 0 0 1-4.5 0V26a.75.75 0 0 1 .75-.75ZM28.25 25.25A.75.75 0 0 1 29 26v.3c0 1.186.258 2.353.75 3.422a8.183 8.183 0 0 0 .75-3.422V26a.75.75 0 0 1 1.5 0v.3c0 1.911-.566 3.78-1.626 5.37a.75.75 0 0 1-1.248 0A9.682 9.682 0 0 1 27.5 26.3V26a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })));
};

export { SvgUv as default };
//# sourceMappingURL=uv.svg.js.map
